module.exports = __webpack_public_path__ + "img/financial_magnates.60ef07d6.webp";